import {AbstractFilePointResponse} from './abstracts/abstract-file-point-response';

export class MoviePointResponse extends AbstractFilePointResponse {

  public constructor() {
    super();
  }
}
